<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="padding: 20px;">
      <div>
        <el-row v-show="!disabled">
        </el-row>
        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>
          <el-table
            :data="tableData"
            :height="th"
            border
            style="width: 100%;"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" width="150" label="姓名"></el-table-column>
            <el-table-column prop="phone" width="150" label="联系电话"></el-table-column>
            <el-table-column prop="relation" width="150" label="与客户关系"></el-table-column>
            <el-table-column prop="isReceive" width="150" label="是否接收信息" :formatter="isReceviceFormat"></el-table-column>
            <el-table-column prop="isLive" width="100" label="是否同住" :formatter="isLiveFormat"></el-table-column>
            <el-table-column prop="address" label="联系地址" ></el-table-column>

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>


  </div>
</template>




<script>
// import {timeStr,timefilters} from "@/common/times";
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";
// import Edit from "./RelativesInfoEdit";

export default {
  name: "Role",
  data() {
    return {
      showModalAdd: false,
      showModalEdit: false,
      disabled: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      userCode: "",
      elderlyCode: "",
      name: "",
      phone: "",
      relation: "",
      isReceive: "",
      isLive: "",
      address: "",
      multipleSelection: [],
      elderlyRelativesCodeList:[]
    };
  },
  created() {
    this.th = this.$store.state.tableHeight-100;
  },
  components: {
  },
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val-100;
    },
    disabled(val){
      this.th = this.$store.state.tableHeight-(val?50:100);
    }
  },
  methods: {
    init(flag,row,disabled){
      if(disabled)this.disabled=disabled
        flag=true;
        this.elderlyCode=row.elderlyCode;
        this.userCode=row.userCode;
        this.getList();
    },
    handleEdit(index, row) {
      this.$refs.myRelativesInfoEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myRelativesInfoAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    handleDelete(row) {
        this.$confirm('您确定要删除这个亲属吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyRelatives/Delete",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyRelativesCode: row.elderlyRelativesCode
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
             this.$message({
            type: 'success',
            message: '删除成功!',
          });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },



     deleteAll() {
        this.$confirm('您确定要删除所选亲属吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           if(this.multipleSelection.length==0){
            this.$message({
            type: 'warning',
            message: '您没有选择亲属!',
          });
          return
          }
        this.elderlyRelativesCodeList=[];
        this.multipleSelection.forEach(element => {
                            this.elderlyRelativesCodeList.push(element.elderlyRelativesCode);
                            }),
        this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyRelatives/DeleteAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyRelativesCodeList: this.elderlyRelativesCodeList
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.$message({
            type: 'success',
            message: '删除成功!',
          });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },

    getList(flag) {
      if(flag)this.currentPage=1
      this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyRelatives/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          elderlyCode: this.elderlyCode,
          userCode: this.userCode,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isReceviceFormat(row) {
      if (row.isReceive == 1) {
        return "是";
      }
      if (row.isReceive == 2) {
        return "否";
      }
      return "其它";
    },
    isLiveFormat(row) {
      if (row.isLive == 1) {
        return "是";
      }
      if (row.isLive == 2) {
        return "否";
      }
      return "其它";
    },
  },
};
</script>

<style scoped>
</style>
